import styled from 'styled-components';

export const WrapperPregunta = styled.div`
  .contenido p {
    margin-bottom: 10px;
  }

  .titulo {
    color: #2e2e2e;
    border: 0 !important;
    padding-top: 0.25rem !important;
    padding-bottom: 2rem !important;
    padding-right: 0rem !important;
  }

  .contenido-padding-fix {
    padding-left: 1rem !important;
    padding-top: 0rem !important;
    padding-right: 1rem !important;
  }

  .contenido {
    display: block;
    padding-left: 1rem;
    padding-right: 1rem;
    gap: 25px;
    justify-content: center;
  }

  .contenido > div {
    padding: 1rem;
    padding-left: 0px;
    padding-right: 0px;
  }

  .subtitulo {
    color: #2e2e2e;
    font-size: 19px;
    font-weight: 500;
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
  }

  .pregunta {
    color: #2e2e2e !important;
    font-size: 18px !important;
    line-height: 24px !important;
  }
`;

export default WrapperPregunta;
